import { dataCubeEyeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCubeEyeSolid = /*#__PURE__*/createIcon(dataCubeEyeSolid)
export default IconCubeEyeSolid
